// Idea taken from https://redux.js.org/recipes/structuring-reducers/refactoring-reducers-example#combining-reducers-by-slice
// Basically each entity (user, terminal etc.) is structured to under one reducer. So when there will be more reducers, those
// just will be added to initialState and slide reducer.

import {LOAD_USERS_REQUEST, LOAD_USERS_SUCCESS, LOAD_USERS_FAILURE, ADD_USER_REQUEST, USERS_EDIT_USER, USERS_DELETE_USER} from '../actions/actionTypes';
import {createReducer, updateObject} from './reducerUtilities';


const initialState = {
    users: {
        usersData: null,
        isLoading: false,
        hasFailed: false
    },
};

// Slice reducer
export const userReducer = createReducer(initialState, {
    [LOAD_USERS_REQUEST] : loadUsersRequest,
    [LOAD_USERS_SUCCESS] : loadUsersSuccess,
    [LOAD_USERS_FAILURE] : loadUsersFailure,
    [ADD_USER_REQUEST] : addUserRequest,
    [USERS_EDIT_USER] : editUser,
    [USERS_DELETE_USER] : deleteUser
});


// -----------------------------------------------------------------------
// LOAD USERS
// -----------------------------------------------------------------------

// Case reducer
function loadUsersRequest(state, action) {
    return {...state, users: updateObject(
        state.users, { 
            isLoading: true 
        })};
}

// Case reducer
function loadUsersSuccess(state, action) {   
    return {...state, users: updateObject(
        state.users, { 
            usersData: action.payload.users, 
            isLoading: false 
        })};
}

// Case reducer
function loadUsersFailure(state, action) {
    return {...state, users: updateObject(
        state.users, { 
            usersData: [], 
            isLoading: false, 
            hasFailed: true 
        })};
}

function addUserRequest(state, action) {
    return {...state, users: updateObject(
        state.users, { 
            usersData: [...state.users.usersData, action.data]
        })};    
}

function editUser(state, action) {
    return {...state, users: updateObject(
        state.users, { 
            usersData: state.users.usersData.map(c => c.id === action.data.id ? action.data : c)
        })}; 
}

function deleteUser(state, action) {
    let newUsers = state.users.usersData;
    const indx = newUsers.findIndex(t => t.id === action.data);
    if(indx > -1) {
        newUsers.splice(indx, 1);
    }
    return {...state, users: updateObject(
        state.users, {
            usersData: newUsers
        }
    )}
}


// WEBPACK FOOTER //
// ./src/reducers/userReducer.js